import {Appearance} from '@stripe/stripe-js'
import {twColor} from 'utils/tailwind/twColor'

export const appearance: Appearance = {
  labels: 'above',
  rules: {
    '.Input': {
      backgroundColor: '#F6F5F5',
      lineHeight: '24px',
      // fontFamily: 'Inter',
      border: `1px solid ${twColor('input-border')}`,
      boxShadow: 'none',
      borderRadius: '8px',
      padding: '12px 8px',
      color: '#06273F',
      // marginBottom: '4px',
      outline: 'none',
      transition: 'none',
      // colorTextPlaceholder: twColor('input-placeholder'),
    },

    '.Input:hover': {
      boxShadow: 'none',
      borderColor: twColor('theme'),
    },

    '.Input:focus': {
      boxShadow: 'none',
      borderColor: `${twColor('theme')}`,
    },

    '.Input--invalid': {
      color: '#06273F',
      borderColor: '#F10030',
      borderWidth: '2px',
      boxShadow: 'none',
    },

    '.Label': {
      color: '#06273F',
      fontWeight: '400',
      // fontFamily: 'Inter',
      fontSize: '15px',
      lineHeight: '24px',
    },

    '.Label--invalid': {
      color: '#F10030',
    },

    '.Error': {
      color: twColor('brand-red'),
      fontSize: '12px',
      marginTop: '6px',
      marginLeft: '26px',
    },

    '.Accordion': {
      transition: 'none',
    },
  },
}
